import { ACCOUNTS, CAMPAIGNS, CONTACT, FUND, HEATMAPS, MARKETINGS, OPPORTUNITIES, PROGRAMS } from "./routes";

const constants = {
	SIDEBAR_STATE_STORAGE_KEY: 'sidebar_mode',

	GLOBAL_ACTION_INIT_STATE: 'GLOBAL_ACTION_INIT_STATE',

	STORAGE_SIGNED_USER_KEY: "connact-user-data",

	MENU_DATA: "menu-data",

	USER_ROLE_ADMIN: 'user-role-admin',

	DATETIME_FOTMAT: 'HH:mm DD/MM/YYYY',

	PAGE_AUTH_TYPE_NONE: 'page-auth-none',
	PAGE_AUTH_TYPE_USER: 'page-auth-user',
	PAGE_AUTH_TYPE_ADMIN: 'page-auth-admin',

	TOAST_TYPE_INFO: 'toast_info',
	TOAST_TYPE_SUCCESS: 'toast_success',
	TOAST_TYPE_WARN: 'toast_warn',
	TOAST_TYPE_ERROR: 'toast_error',

	CACHE_LAYER_RESULT_TYPE_NONE: 'none',
	CACHE_LAYER_RESULT_TYPE_PARTIAL: 'partial',
	CACHE_LAYER_RESULT_TYPE_FULL: 'full',

	TOP_HEIGHT: 55,
	PAGE_TITLE_HEIGHT: 50,
	POPUP_TITLE_HEIGHT: 70,
	DEFAULT_VIDEO_LIST_PAGE_SIZE: 15,
	DEFAULT_CLIENT_LIST_PAGE_SIZE: 20,
	DEFAULT_CLIENT_PHOTO_LIST_PAGE_SIZE: 20,

	IS_INTERNAL_LOGIN: 'is_internal_login',

	REQUEST_A_FEATURE_FORM_URL: 'https://forms.office.com/pages/responsepage.aspx?id=7nySfs-zv0uJZkbYB8FJCEeTk5ajU3xCpn-lELicis1UNVBZT0NVWVJPSzIzV0lPOEk5WDJYM0U1WC4u&route=shorturl',

	REPORT_HIDDEN_COLUMNS: 'report_hidden_columns',
	CAMPAIGN_HIDDEN_COLUMNS: 'campaign_hidden_columns',
	DISPLAY_ENTITIES: {
		OPPORTUNITIES: 'opportunities',
		CO_SELL_OPPORTUNITIES: 'co_sell_opportunities',
		HEATMAPS: 'heatmaps',
		CAMPAIGNS: 'campaigns',
		CAMPAIGN_MEMBERS: 'campaign_members',
		ACCOUNTS: 'accounts',
		CONTACTS: 'contacts',
		PROGRAMS: 'programs',
		FUNDS: 'funds',
		MARKETING: 'marketing'
	}
	
};

export default constants;
